import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { BaseTypography } from '../BaseTypography/BaseTypography';
import { successColor } from '../../../materialConfig/theme';

export enum EChipType {
  Info,
  Warning,
  Danger,
  Success,
  Locked,
}

const getChipBg = (type: EChipType) => {
  const w = [
    [EChipType.Info, '#7AC5F1'],
    [EChipType.Warning, '#F1DD75'],
    [EChipType.Danger, '#DE5753'],
    [EChipType.Success, successColor],
    [EChipType.Locked, '#9EA8AB'],
  ];
  const found = w.find(([itemType]) => itemType === type);
  return (found && found[1]) || '#7AC5F1';
};

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-block',
    padding: '5px',
    // @ts-ignore
    background: ({ type }) => getChipBg(type),
    borderRadius: '5px',
  },
  data: {
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '16px',
    color: 'white',
  },
}));

type PBaseChip = {
  className?: any;
  type?: EChipType;
  upperCase?: boolean;
  [key: string]: any;
};

export const BaseChip: React.FC<PBaseChip> = (props) => {
  const {
    className,
    children,
    type = 'info',
    upperCase = false,
    ...otherProps
  } = props;
  const classes = useStyles({ type });
  return (
    <div
      className={clsx(classes.root, className)}
      style={{ textTransform: upperCase ? 'uppercase' : 'unset' }}
      {...otherProps}
    >
      <BaseTypography className={classes.data}>{children}</BaseTypography>
    </div>
  );
};
